// Estilos compartidos para los botones de micrófono (dictado) y parlante (lectura)
// del kanban, para que se vean como controles destacados en vez de íconos planos.

export const micButtonSx = (active) => ({
  borderRadius: '50%',
  bgcolor: active ? 'error.main' : 'action.hover',
  color: active ? 'common.white' : 'text.secondary',
  border: '1px solid',
  borderColor: active ? 'error.main' : 'divider',
  transition: 'background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    bgcolor: active ? 'error.dark' : 'action.selected',
  },
  '&.Mui-disabled': {
    bgcolor: 'action.disabledBackground',
    borderColor: 'divider',
  },
  ...(active && {
    '@keyframes enpisoMicPulse': {
      '0%': { boxShadow: '0 0 0 0 rgba(211, 47, 47, 0.45)' },
      '70%': { boxShadow: '0 0 0 8px rgba(211, 47, 47, 0)' },
      '100%': { boxShadow: '0 0 0 0 rgba(211, 47, 47, 0)' },
    },
    animation: 'enpisoMicPulse 1.6s ease-out infinite',
  }),
});

export const speakerButtonSx = (active) => ({
  borderRadius: '50%',
  bgcolor: active ? 'primary.main' : 'action.hover',
  color: active ? 'common.white' : 'text.secondary',
  border: '1px solid',
  borderColor: active ? 'primary.main' : 'divider',
  transition: 'background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    bgcolor: active ? 'primary.dark' : 'action.selected',
  },
  '&.Mui-disabled': {
    bgcolor: 'action.disabledBackground',
    borderColor: 'divider',
  },
  ...(active && {
    boxShadow: (theme) => `0 0 0 4px ${theme.palette.primary.main}26`,
  }),
});
